// src/pages/Careers.js
import React from 'react'
import { Box, Container, Typography, Card, CardContent, Stack, Button } from '@mui/material'
import { Work as WorkIcon, Mail as MailIcon } from '@mui/icons-material'
import { useLanguage } from '../contexts/LanguageContext'

const Careers = () => {
    const { t, lang } = useLanguage()
    const isFr = lang === 'fr'
    const tt = (key, enFallback, frFallback) => t(key, null, isFr ? frFallback : enFallback)

    return (
        <Box sx={{ py: { xs: 5, md: 7 } }}>
            <Container maxWidth="md">
                <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1 }}>
                    <WorkIcon />
                    <Typography component="h1" variant="h4" sx={{ fontWeight: 950, color: 'white' }}>
                        {tt('careers.title', 'Careers', 'Carrières')}
                    </Typography>
                </Stack>

                <Card sx={{ borderRadius: 6, bgcolor: 'rgba(15,23,42,0.72)', border: '1px solid rgba(255,255,255,0.10)' }}>
                    <CardContent>
                        <Typography sx={{ color: 'rgba(255,255,255,0.75)' }}>
                            {tt(
                                'careers.body',
                                "We'll post open roles here. For now, send your resume and what role you want.",
                                'Nous publierons les postes ouverts ici. Pour le moment, envoyez votre CV et le poste souhaité.'
                            )}
                        </Typography>

                        <Button
                            sx={{ mt: 2, borderRadius: 999, fontWeight: 900 }}
                            variant="contained"
                            startIcon={<MailIcon />}
                            href="mailto:careers@mojopayr.com?subject=MojoPayr%20Careers"
                        >
                            {tt('careers.cta', 'Email careers@mojopayr.com', 'Écrire à careers@mojopayr.com')}
                        </Button>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    )
}

export default Careers

